import Marquee from "react-fast-marquee";

const WORDS = ["Build", "Automate", "Grow", "Build", "Automate", "Grow"];

const MarqueeStrip = () => (
    <div className="border-y border-slate-200 bg-white py-10 md:py-14 overflow-hidden" data-testid="editorial-marquee">
        <Marquee speed={18} gradient={false}>
            {WORDS.map((w, i) => (
                <span key={i} className="flex items-center mx-10 md:mx-16">
                    <span
                        className={`font-display font-semibold uppercase tracking-tight text-5xl md:text-7xl ${
                            i % 2 === 0 ? "text-stroke-navy" : "text-navy/10"
                        }`}
                    >
                        {w}
                    </span>
                    <span className="ml-10 md:ml-16 w-3 h-3 rounded-full bg-accent/60" />
                </span>
            ))}
        </Marquee>
    </div>
);

export default MarqueeStrip;
